





























































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import DataUtility from "@/services/DataUtility";
import DataSKDP from "@/services/DataSKDP";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storeSkDiagnosa } from "@/store/modules/skdiagnosa";
import moment from "moment";
import { storeSoap } from "@/store/modules/soap";
import { storePasien } from "@/store/modules/pasien";
import DataSkDiagnosa from "@/services/DataSkDiagnosa";
import { listTindakLanjut } from "@/utility/DataReferensi";

@Component({
  components: {
    CardModalTtd
  },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class CardInputSkDiagosa extends Vue {
  // @Prop() readonly sess_login!: object;
  @Prop() readonly value!: boolean;
  @Prop() readonly register!: string;
  @Prop() dataSkDiagnosa!: string;

  isReadOnly!: () => boolean;
  get readOnly(): boolean {
    return this.isReadOnly();
  }

  dokter = {};
  tindakLanjut = {};
  klinikTujuan = {};
  diagnosis = "";
  alasan = "";
  rtl = "";
  tglRujukan = "";
  tglKontrol = "";
  sess_login = userModule.user;
  listDokter = {};
  listKlinikTujuan = [];
  alert = "";
  validasi = [v => !!v || "*Kolom ini harus diisi"];
  err = {};
  modalTtdSkDiagnosis = false;
  expandInput = false;
  saving = false;

  // get show() {
  //   return this.value;
  // }

  // set show(value) {
  //   this.$emit("input", value);
  // }

  get listTindakLanjut() {
    return listTindakLanjut;
  }

  get statePasien() {
    return storePasien.identitasPasien;
  }
  mounted() {
    this.getDpjp();
    this.getKlinikTujuan();
    this.klinikTujuan = { id: "0", nama: "-Pilih Klinik Tujuan-" };
    this.getSkdp();
  }

  get statedetaildiagnosa() {
    return storeSkDiagnosa.detailSkDiagnosa;
  }
  get statesoapdetail() {
    return storeSoap.detailSoap;
  }

  passTtd(value) {
    this.$emit("passTtd", value);
    // this.modalTtdSkDiagnosis = false;
  }

  @Watch("dataSkDiagnosa")
  getSkdp() {
    // console.log(this.dataSkDiagnosa);
    if (this.dataSkDiagnosa["dokter"] == undefined) {
      this.dokter = { id: this.sess_login.id, nama: this.sess_login.nama };
      this.diagnosis = this.statesoapdetail[0].a;
      this.tindakLanjut = {};
      this.klinikTujuan = { id: "0", nama: "-Pilih Klinik Tujuan-" };
    } else {
      this.dokter = this.dataSkDiagnosa["dokter"];
      this.diagnosis = this.dataSkDiagnosa["diagnosis"];
      const tl = this.dataSkDiagnosa["tindak_lanjut"].id;
      const klinik = this.dataSkDiagnosa["klinik_tujuan"].id;
      this.tindakLanjut = {
        id: this.dataSkDiagnosa["tindak_lanjut"].id,
        nama: this.dataSkDiagnosa["tindak_lanjut"].nama
      };
      this.klinikTujuan = {
        id: this.dataSkDiagnosa["klinik_tujuan"].id,
        nama: this.dataSkDiagnosa["klinik_tujuan"].nama
      };
    }
  }

  getDpjp() {
    const dktr = DataUtility.getListDokter();
    dktr.then(dktr => {
      this.listDokter = dktr;
    });
  }

  getKlinikTujuan() {
    const unit = DataUtility.getListUnitRalanPagi();
    unit.then(unit => {
      this.listKlinikTujuan = unit;
    });
  }

  simpanSkDiagnosa() {
    if (this.readOnly) return;
    // const svDiagnosa = { ...this.statedetaildiagnosa };
    if (
      this.diagnosis == "" ||
      this.tindakLanjut["id"] == undefined ||
      (this.tindakLanjut["id"] == "1" && this.klinikTujuan["id"] == "0")
      // this.klinikTujuan.id == "0"
    ) {
      this.alert =
        "Kolom Surat Keterangan Diagnosa tidak boleh ada yang kosong";
      appModule.sendErrorAlert(this.alert);
    } else {
      if (!this.saving) {
        this.saving = true;
        // appModule.setLoading(true);
        if (this.dataSkDiagnosa["id"] == null) {
          // const a = this.tindakLanjut["id"] + " " + this.klinikTujuan.id;
          // alert("simpan " + a);
          // console.log("Simpan");
          const dt = DataSkDiagnosa.saveDataSkDiagnosa(
            this.register,
            this.statePasien.rm,
            this.dokter["id"],
            this.sess_login["unit_id"],
            this.diagnosis,
            this.tindakLanjut["id"],
            this.klinikTujuan["id"]
          );
          dt.then(dt => {
            this.saving = false;
            // appModule.setLoading(false);
            if (dt["status"] != 1) {
              // appModule.sendErrorAlert(dt["err"]);
            } else {
              const id = dt["data"].id;
              // console.log("id = ", id);
              storeSkDiagnosa.actSKD_on_reg(this.register);
              storeSkDiagnosa.actSKD_on_id(id);
              this.modalTtdSkDiagnosis = true;
              // this.show = false;
              appModule.NoticeDelay(
                "Berhasil Simpan Surat Keterangan Diagnosa"
              );
              this.close();
            }
          });
        } else {
          // alert("edit");
          // console.log("Edit");
          const dt = DataSkDiagnosa.changeDataSkDiagnosa(
            this.dataSkDiagnosa["id"],
            this.dataSkDiagnosa["register_id"],
            this.statePasien.rm,
            this.dokter["id"],
            this.sess_login["unit_id"],
            this.diagnosis,
            this.tindakLanjut["id"],
            this.klinikTujuan["id"]
          );
          dt.then(dt => {
            this.saving = false;
            // appModule.setLoading(false);
            if (dt["status"] != 1) {
              // appModule.sendErrorAlert(dt["err"]);
            } else {
              storeSkDiagnosa.actSKD_on_reg(this.register);
              this.modalTtdSkDiagnosis = true;
              // this.show = false;
              appModule.NoticeDelay("Berhasil Ubah Surat Keterangan Diagnosa");
              this.close();
            }
          });
        }
      }
    }
  }

  close() {
    // this.show = false;
    this.expandInput = false;
    this.$emit("close", this.expandInput);
  }

  get tglRujukanFormattedMomentjs() {
    return this.tglRujukan
      ? moment(this.tglRujukan).format("DD MMMM YYYY")
      : "";
  }

  get tglKontrolFormattedMomentjs() {
    return this.tglKontrol
      ? moment(this.tglKontrol).format("DD MMMM YYYY")
      : "";
  }

  changeTindakLanjut() {
    this.klinikTujuan = { id: "0", nama: "-Pilih Klinik Tujuan-" };
  }
}
